import defaultValues from "config:./defaultValues";
import { retrieveValueAtProperty } from "./generalUtils/valueFetch";
import { getRegion } from "./generalUtils/envFns";

declare global {
  interface Window {
    dataLayer: Array<any>;
    eswDataLayer: Array<any>;
    automatedDataLayer: Array<any>;
  }
}

const DATALAYER_DEFAULT = "dataLayer";

// This must be in the head!
function gtmInit(
  containerId: string,
  dataLayerName = DATALAYER_DEFAULT,
  additionalParam = ""
) {
  return new Promise<Event>((res, rej) => {
    const region = getRegion();
    let googlePath = "https://www.googletagmanager.com";
    if (region === "ca" || region === "us") {
      googlePath = `https://shop.lululemon.com/metrics/${region}`;
    }
    window[dataLayerName] = (window[dataLayerName] ?? []) as Array<unknown>;
    window[dataLayerName].push({
      "gtm.start": new Date().getTime(),
      event: "gtm.js",
    });

    if (defaultValues?.useGTG) {
      googlePath = `https://shop.lululemon.com/metrics/${region}`;
    }

    const gtmLoad = document.createElement("script");
    gtmLoad.async = true;
    // Should we add defer?
    const dataLayerString = "&l=" + dataLayerName;
    gtmLoad.src = `https://www.googletagmanager.com/gtm.js?id=${containerId}${dataLayerString}${additionalParam}`;
    gtmLoad.onload = res;
    gtmLoad.onerror = rej;
    document.head.insertBefore(gtmLoad, document.head.firstChild);
  });
}

export async function storeAndInitGTM(additionalParam?: string) {
  const CONTAINER_ID = "containerId";
  if (defaultValues[CONTAINER_ID] === undefined) {
    return Promise.resolve();
  }

  const DATA_LAYER_NAME = "dataLayerName";
  const GTAG_OPTS = "gtagOptions";
  const queryElements = new URLSearchParams(window.location.search);
  // Query Parameters -> Session Storage -> Federated Modules -> Window
  const gtmId = retrieveValueAtProperty(
    queryElements,
    CONTAINER_ID,
    defaultValues[CONTAINER_ID]
  );
  const dataLayerName = retrieveValueAtProperty(
    queryElements,
    DATA_LAYER_NAME,
    defaultValues[DATA_LAYER_NAME]
  );
  // TODO: Add ability to have null case in gtagId function of config
  const gtagDetails = retrieveValueAtProperty(
    queryElements,
    GTAG_OPTS,
    defaultValues[GTAG_OPTS]
  );

  if (gtmId === null) {
    throw new Error("Missing GTM container ID");
  }

  if (gtagDetails !== undefined) {
    const gtagCalls =
      typeof gtagDetails === "function" ? gtagDetails() : gtagDetails;
    function pushToDataLayer(..._args: unknown[]) {
      if (window[dataLayerName] === undefined) {
        // @ts-ignore
        window[dataLayerName] = [];
      }
      window[dataLayerName]["push"](arguments);
    }
    pushToDataLayer("js", new Date());
    gtagCalls.forEach((opt) => {
      pushToDataLayer(...opt);
    });
  }

  return gtmInit(gtmId, dataLayerName, additionalParam)
    .then(() => {
      console.log("GTM Initialized");
      if (defaultValues.onGTMReady) {
        defaultValues.onGTMReady();
      }
    })
    .catch((err) => {
      console.error(err);
      console.error(err.message);
    });
}
